import { useState } from "react";
import { AccordionHeader, AccordionHeaderText } from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { KeyDetail } from "../../../createProject/components/createProjectGeneralDetail/keyDetail/KeyDetail";
import { keyProjectDetailsSiteCoreKeys } from "../../../createProject/siteCore/SiteCoreKeys";
import { ViewProjectKeyDetailsWrapper } from "./ViewProjectKeyDetails.style";

export const ViewProjectKeyDetails = () => {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(true);
  const { fetchComponentTitle } = useSiteCore();

  return (
    <ViewProjectKeyDetailsWrapper>
      <PermissionWrapper
        permission={MODULE_PERMISSIONS.PROJECT_VIEW_KEY_PROJECT_DETAILS}
      >
        <AccordionHeader
          title={
            <AccordionHeaderText
              label={fetchComponentTitle(
                keyProjectDetailsSiteCoreKeys.keyProjectDetails,
              )}
            />
          }
          onChange={() => setIsAccordionExpanded(!isAccordionExpanded)}
          isExpanded={isAccordionExpanded}
        >
          <KeyDetail />
        </AccordionHeader>
      </PermissionWrapper>
    </ViewProjectKeyDetailsWrapper>
  );
};
